import { MotionMasterMessage } from 'motion-master-client';

export type PlaygroundControllerType = 'position' | 'velocity' | 'torque';

export const controlOptions: PlaygroundControllerType[] = ['position', 'velocity', 'torque'];

export const controlOptionToControllerMap: {
  [K in PlaygroundControllerType]: MotionMasterMessage.Request.EnableMotionController.ControllerType;
} = {
  position: MotionMasterMessage.Request.EnableMotionController.ControllerType.POSITION,
  torque: MotionMasterMessage.Request.EnableMotionController.ControllerType.TORQUE,
  velocity: MotionMasterMessage.Request.EnableMotionController.ControllerType.VELOCITY,
};

export interface Playground {
  /**
   * Belongs to Device [FK].
   * **NOTE**: This is the Primary Key (PK) as there is only one Playground per device.
   */
  deviceSerialNumber: string;

  /**
   * How much to increase the position input value on -/+ buttons.
   */
  positionStepSize: number;

  /**
   * Selected control is one of position, velocity or torque.
   */
  selectedControl: PlaygroundControllerType;

  /**
   * How much to increase the torque input value on -/+ buttons.
   */
  torqueStepSize: number;

  /**
   * How much to increase the velocity input value on -/+ buttons.
   */
  velocityStepSize: number;
}

export const defaultPlayground: Partial<Playground> = {
  positionStepSize: 1,
  selectedControl: 'torque',
  torqueStepSize: 20,
  velocityStepSize: 50,
};
